export default __webpack_public_path__ + "media/images/btnlogin-c72514f8108e114f3141760cd422bab1.png";